module fdm.flightEvents {

    export class eventsIn100LegsYtdChartController {


        public queryResult: any;
        public query: any;
        public data: any;
        public layout: any;
        public options: any;
        public events: any;
        public loading: any;
        private xItems: Array<string> = [];
        private xItemsPlaceholder: Array<string> = [];

        public constructor(
            private actionService: dg.actions.ActionService,
            private $scope: any,
            private navigationService: dg.navigation.NavigationService,
            private chartService: dg.lists.ChartService,
            private uiService: dgUtils.UiService,
            private severityLevelService: SeverityLevelService) {

        }

        $onChanges(changes) {
            if (changes.queryResult && changes.queryResult.currentValue) {
                this.xItems = [];
                this.xItemsPlaceholder = [];
                this.generateChart();
            }
        }

        public static generateTrace = (traceName: string, xValues, yValues, yAxis, color: string) => {
            let trace: any = {
                x: xValues,
                y: yValues,
                yaxis: yAxis,
                name: traceName,

                marker: {
                    color: color
                },
                //line: {
                //    width: 1
                //},
                type: 'scatter'

            };
            if (yValues.length == 0) {
                trace.y = Array.apply(null, Array(xValues.length)).map(Number.prototype.valueOf, 0);
            }

            return trace;
        }

        public generateChart = () => {
            const GREY_COLOR = 'rgb(127,127,127)';

            let xValues = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
            //let xValues = ['2016-01-01', '2016-02-01', '2016-03-01', '2016-04-01', '2016-05-01', '2016-06-01', '2016-07-01', '2016-08-01', '2016-09-01', '2016-10-01', '2016-11-01', '2016-12-01'];
            
            let minorLevels: Array<number> = [];
            let majorLevels: Array<number> = [];
            let criticalLevels: Array<number> = [];

            //for (let i = 0; i < this.queryResult.items.length; i += 1) {
            //    let item = <iteraFDM.domain.flightEvents.FlightPhaseEventsInfo>this.queryResult.items[i];
            //    this.xItems.push(item.phase.id);
            //    this.xItemsPlaceholder.push((<any>item.phase).description);
            //    minorLevels.push(item.minorCount);
            //    majorLevels.push(item.majorCount);
            //    criticalLevels.push(item.criticalCount);
            //}

            let baselineMinorValues = this.chartService.getBaselinePeriodEventsByMonth(this.queryResult.minor.monthlyTrends);
            let focusMinorValues = this.chartService.getFocusPeriodEventsByMonth(this.queryResult.minor.monthlyTrends);

            let baselineMajorValues = this.chartService.getBaselinePeriodEventsByMonth(this.queryResult.major.monthlyTrends);
            let focusMajorValues = this.chartService.getFocusPeriodEventsByMonth(this.queryResult.major.monthlyTrends);

            let baselineCriticalValues = this.chartService.getBaselinePeriodEventsByMonth(this.queryResult.critical.monthlyTrends);
            let focusCriticalValues = this.chartService.getFocusPeriodEventsByMonth(this.queryResult.critical.monthlyTrends);

            let minorBaselinePeriodTrace = fdm.flightEvents.eventsIn100LegsYtdChartController.generateTrace('Baseline', xValues, baselineMinorValues, 'y', GREY_COLOR);
            let minorFocusTrace = fdm.flightEvents.eventsIn100LegsYtdChartController.generateTrace('Focus', xValues, focusMinorValues, 'y', this.severityLevelService.getColor("Minor"));

            let majorBaselinePeriodTrace = fdm.flightEvents.eventsIn100LegsYtdChartController.generateTrace('Baseline', xValues, baselineMajorValues, 'y2', GREY_COLOR);
            let majorFocusTrace = fdm.flightEvents.eventsIn100LegsYtdChartController.generateTrace('Focus', xValues, focusMajorValues, 'y2', this.severityLevelService.getColor("Major"));

            let criticalBaselinePeriodTrace = fdm.flightEvents.eventsIn100LegsYtdChartController.generateTrace('Baseline', xValues, baselineCriticalValues, 'y3', GREY_COLOR);
            let criticalFocusTrace = fdm.flightEvents.eventsIn100LegsYtdChartController.generateTrace('Focus', xValues, focusCriticalValues, 'y3', this.severityLevelService.getColor("Critical"));

            //var minorLevelsBar = {
            //    x: this.xItems,
            //    y: minorLevels,
            //    marker: {
            //        color: MINOR_COLOR
            //    },
            //    type: 'bar',
            //    name: 'Minor'
            //}

            //var majorLevelsBar = {
            //    x: this.xItems,
            //    y: majorLevels,
            //    marker: {
            //        color: MAJOR_COLOR
            //    },
            //    type: 'bar',
            //    name: 'Major'
            //}

            //var criticalLevelsBar = {
            //    x: this.xItems,
            //    y: criticalLevels,
            //    marker: {
            //        color: CRITICAL_COLOR
            //    },
            //    type: 'bar',
            //    name: 'Critical'
            //}

            this.data = [minorBaselinePeriodTrace, minorFocusTrace, majorBaselinePeriodTrace, majorFocusTrace, criticalBaselinePeriodTrace, criticalFocusTrace];
            //console.log(this.data)
            //console.log(this.queryResult)
            this.layout = {
                //hovermode: 'closest',
                //barmode: 'group',
                height: 500,
                showlegend: false,
                margin: {
                    t: 10,
                    b: 40,
                    l: 35,
                    //l: 50,
                    r: 0
                },
                //legend: {
                //    xanchor: "right",
                //    yanchor: "top",
                //    orientation: "h",
                //    y: 10,
                //    font: {
                //        //family: 'sans-serif',
                //        //size: 11,
                //        //color: '#686868'
                //    },
                //    x: 1
                //},
                xaxis: {
                    type: 'category',
                    //tickmode: 'array',
                    //tickvals: ['2016-01-01', '2016-02-01', '2016-03-01', '2016-04-01', '2016-05-01', '2016-06-01', '2016-07-01', '2016-08-01', '2016-09-01', '2016-10-01', '2016-11-01', '2016-12-01'],
                    //ticktext: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
                    rangemode: 'nonegative',
                    fixedrange: true
                    //tickfont: {
                    //    //family: "serif",
                    //    //size: 11,
                    //    //color: "#666666"
                    //},
                },
                yaxis: {
                    domain: [0, 0.3],
                    //titlefont: { color: MINOR_COLOR },
                    //title: 'Minor',
                    fixedrange: true,
                    rangemode:'tozero',

                },
                yaxis2: {
                    domain: [0.35, 0.65],
                    //titlefont: { color: MAJOR_COLOR },
                    //title: 'Major',
                    fixedrange: true,
                    rangemode: 'tozero'
                },
                yaxis3: {
                    domain: [0.7, 1],
                    //titlefont: { color: CRITICAL_COLOR },
                    //title: 'Critical',
                    fixedrange: true,
                    rangemode: 'tozero'
                },
                //margin: {
                //    t: 10,
                //    b: 45,
                //    l: 45,
                //    r: 30
                //},
            };

            this.options = {
                showLink: false,
                displayLogo: false,
                displayModeBar: false
            };

            //this.events = (graph) => {

            //    graph.on('plotly_click', (data) => {
            //        if (data.points) {
            //            let name = data.points[0].x;
            //            let link = this.uiService.getLinkByProperty('phase', name, this.queryResult);
            //            this.navigationService.navigate(link, this.query);
            //        }
            //    });

            //    graph.on('plotly_hover', (data) => {
            //        let infoText = this.chartService.getItemByIndex(data, this.xItems, this.xItemsPlaceholder);

            //        this.chartService.setPlaceholderText(infoText, data.points[0].x);
            //    });
            //};
        }

        //public getLinkByProperty(property: string, phaseName: string, queryResult: any) {
        //     for (let i = 0; i < queryResult.items.length; i += 1) {
        //         if (queryResult.items[i][property].displayValue == phaseName) {
        //             return queryResult.items[i].dgMeta.links.viewEvents;
        //         }
        //     }
        // }
    }


    angular.module('fdm.flightEvents').component('eventsIn100LegsYtdChart', {
        bindings: {
            queryResult: '<',
            loading: '<',
            query: '<'
        },
        controller: eventsIn100LegsYtdChartController,
        templateUrl: '/digmo/src/lists/chart/plotly-chart-instance.html'
    });
}